<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="650px"
    :innerScroll="false"
    :loading="loadingButtom"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="addForm" ref="addForm" :rules="rules" size="small" label-width="120px">
      <el-table
        :data="tableData"
        ref="tableRef"
        border
        stripe
        highlight-current-row
        :height="300"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        v-loading="loading"
      >
        <el-table-column label="上限" prop="limitUpper">
          <template slot-scope="scope">
            <el-input v-model="scope.row.limitUpper" @blur="limitUpperInput(scope.row, scope.$index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="下限" prop="limitLower">
          <template slot-scope="scope">
            <el-input v-model="scope.row.limitLower" @blur="limitLowerInput(scope.row, scope.$index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="系数" prop="commissionCoefficient">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.commissionCoefficient"
              @blur="commissionCoefficientInput(scope.row)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px" align="center">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="add(scope)">新增</el-link>
            <el-link type="primary" :underline="false" @click="del(scope)" style="color: red" v-if="tableData && tableData.length > 1">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </q-dialog>
</template>

<script>
import axios from "@/utils/axiosInstance";
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    tableDataList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      addForm: {
        storeCodeList: [],
      },
      rules: {
      },
      loading: false,
      loadingButtom: false,
      tableData: [],
      error: false
    };
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "修改";
    },
  },
  mounted() {
    this.tableData = JSON.parse(JSON.stringify(this.tableDataList))
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      // if(this.error) return
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        let data = this.tableData
        this.$q.newProduct
          .commissionConfigUpdate({ data: data })
          .then((res) => {
            if (res.code == 200) {
              let text = this.title + "成功";
              this.$message.success(text);
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
    add(scope) {
      
      let data = {
        limitUpper: scope.row.limitLower,
        limitLower: "",
        commissionCoefficient: "",
        dataId: "",
      }
      this.tableData.splice(scope.$index + 1, 0, data);
      
    },
    del(scope) {
      this.tableData.splice(scope.$index, 1);
      if(this.tableData[scope.$index - 1] && this.tableData[scope.$index]) {
        this.tableData[scope.$index - 1].limitLower = this.tableData[scope.$index].limitUpper
      }
    },
    limitUpperInput(row, index) {
      if (!row.limitUpper) return;
      let value = row.limitUpper + "";
      var reg = /^(0|[1-9]\d*)$/;;
      if (!value.match(reg)) {
        this.$message.error("请输入正整数!");
        this.error = true;
        row.limitUpper = "";
      } else {
        if (this.tableData[index - 1]) {
          this.tableData[index - 1].limitLower = row.limitUpper;
        }
        this.error = false;
      }
    },
    limitLowerInput(row, index) {
      if (!row.limitLower) return;
      let value = row.limitLower + "";
      var reg = /^(0|[1-9]\d*)$/;
      if (!value.match(reg)) {
        this.$message.error("请输入正整数!");
        this.error = true;
        row.limitLower = "";
      } else {
        if (this.tableData[index + 1]) {
          this.tableData[index + 1].limitUpper = row.limitLower;
        }
        this.error = false;
      }
    },
    commissionCoefficientInput(row,index) {
      if (!row.commissionCoefficient) return;
      let value = row.commissionCoefficient + '';
      var reg = /^\d+(\.\d{1,2})?$/  
      if (!value.match(reg)) {
        this.$message.error("请输入正整数且最多包含2位小数的数字!");
        this.error = true;
        row.commissionCoefficient = "";
      } else {
         this.error = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 100% !important
>>> .el-input
  width 100% !important
>>> .el-input__inner
  text-align center

>>> .el-select__tags-text {
display: inline-block;
max-width: 60px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
